\rentware-header
    width: 100%
    .HeaderContainer
        width: 100%
        display: flex
        flex-direction: row
        justify-content: space-between
        align-items: center
        color: rgb($globalSettingsFontPrimary)
        .HeaderTitle
            font-size: 24px
            line-height: 1.4
            display: inline-block
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis